/* =============================================================================
   Thirsty Threads - Match the Crew size labels (added 2 October 2026)

   Ella's "Match the Crew" (product bundle) cards keep saying CHOOSE SIZE
   even after a size has been picked - the chosen size only shows inside the
   closed size popover - so shoppers could not tell a size was selected.
   This mirrors the chosen size onto each card's button: "SIZE: L".
   If no size is chosen yet (the popover header reads "Please select"), the
   button keeps Ella's original CHOOSE SIZE label.

   Reads the size group's header ([data-header-option]), which Ella and
   assets/custom.js keep up to date. Display only - no cart logic here.

   13 Oct 2026 (QA fixes): low-stock line in the size popover.
   - It read "Hurry up! Only 4 left" right under the size buttons (4, 6, 8...)
     so it could be read as "size 4". Now: "Only 4 left in this size".
   - Ella rendered it for the first available size before the shopper had
     picked anything (even beside "Please select"). It is now hidden until a
     size is chosen; Ella's product-bundle.js then shows it (display:block)
     for the chosen size only.
   ============================================================================= */
(function () {
  var PLACEHOLDER = /please select|choose/i;

  window.inventory_text = window.inventory_text || {};
  window.inventory_text.hotStock = 'Only [inventory] left in this size';

  try {
    var css = document.createElement('style');
    css.textContent = 'product-bundle .bundle-hotStock:not([style*="display: block"]){display:none!important}' +
      'product-bundle .bundle-hotStock{margin-top:8px;color:#B42318;font-size:13px;font-weight:700}';
    document.head.appendChild(css);
  } catch (e) {}

  function update() {
    var cards = document.querySelectorAll('product-bundle .bundle-product-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var toggle = card.querySelector('.bundle-product-toogle');
      if (!toggle) continue;
      if (!toggle.hasAttribute('data-tt-label')) {
        toggle.setAttribute('data-tt-label', toggle.textContent.replace(/\s+/g, ' ').trim());
      }
      var headers = card.querySelectorAll('[data-header-option]');
      var sizeHeader = headers.length ? headers[headers.length - 1] : null;
      var size = sizeHeader ? sizeHeader.textContent.replace(/\s+/g, ' ').trim() : '';
      var label = size && !PLACEHOLDER.test(size)
        ? 'SIZE: ' + size
        : toggle.getAttribute('data-tt-label');
      if (toggle.textContent.trim() !== label) {
        toggle.textContent = label;
        toggle.setAttribute('aria-label', size && !PLACEHOLDER.test(size) ? 'Change size, ' + size + ' selected' : label);
      }
    }
  }

  function later() { setTimeout(update, 60); }

  document.addEventListener('change', later, true);
  document.addEventListener('click', later, true);
  document.addEventListener('tt:bundle-size-change', later);

  var tries = 0;
  (function init() {
    tries++;
    if (document.querySelector('product-bundle .bundle-product-item')) {
      setTimeout(update, 500);
      setTimeout(update, 1500);
      return;
    }
    if (tries < 20) setTimeout(init, 300);
  })();
})();
